import styled from 'styled-components';

const DropdownDivOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-s);
  padding: 12px var(--spacing-s);
  color: var(--font-on-background);
  background: var(--color-background2);
  width: 100%;
  border: none;
  cursor: pointer;

  &:hover {
    background: var(--color-hover);
  }
`;

export default DropdownDivOption;
